import { __extends } from "tslib";
import LanguageDetectorNames from "../constants/LanguageDetectorNames";
import AbstractDetector from "./AbstractDetector";
var MetaTagDetector = /** @class */ (function (_super) {
    __extends(MetaTagDetector, _super);
    function MetaTagDetector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * The detection logic for this class, returns the language string or null when nothing is found.
     *
     * @returns {(string|null)} The language or null if the detector could note validate the language.
     */
    MetaTagDetector.prototype.detect = function () {
        var language = this.getMetaTagValue();
        // Clear the language if the meta tag for this detector value contains 'en'.
        // @todo - make configureable => see comment in DocumentElementDetector
        if (language && this.containsEnglish(language)) {
            language = null;
        }
        return _super.prototype.detect.call(this, language);
    };
    MetaTagDetector.prototype.getName = function () {
        return LanguageDetectorNames.MetaTag;
    };
    /**
     * Check if the meta tag content string contains the 'en' identifier.
     *
     * @param {string} value The string to check for indexOf value.
     * @return {boolean} True if the string contains the indexOf value, otherwise false.
     */
    MetaTagDetector.prototype.containsEnglish = function (value) {
        return value.indexOf("en") > -1;
    };
    /**
     * Get the Content-Language metaTag.
     *
     * @return {(string|null)} The meta tag or null if not found.
     */
    MetaTagDetector.prototype.getMetaTag = function () {
        return document.querySelector('meta[http-equiv="Content-Language"]');
    };
    /**
     * Get the content value associated with the metaTag and normalize it.
     *
     * @return {(string|null)} The meta tag or null if not found.
     */
    MetaTagDetector.prototype.getMetaTagValue = function () {
        if (this.getMetaTag()) {
            return this.getMetaTag()
                .getAttribute("content")
                .toLowerCase();
        }
        return null;
    };
    return MetaTagDetector;
}(AbstractDetector));
export default MetaTagDetector;
//# sourceMappingURL=MetaTagDetector.js.map